import {Button, Modal} from "react-bootstrap";
import DocumentContainer from "../../components/shared/DocumentContainer";

const ModalViewFacture = ({openModal, toggleModal, fileUrl, refrence}) => {
  return (
    <Modal
      className="modal fade "
      show={openModal}
      onHide={toggleModal}
      centered
      size="lg"
    >
      <div className="modal-content ">
        <div className="modal-header">
          <h4 className="modal-title text-[#1A64B9] font-semibold">
            Facture: {refrence}
          </h4>
          <Button
            variant=""
            type="button"
            className="close"
            onClick={() => toggleModal(false)}
          >
            <span>×</span>
          </Button>
        </div>
        <div className="modal-body !py-3 !px-0 h-[70vh] overflow-scroll overflow-style-none">
          <DocumentContainer fileUrl={fileUrl} />
        </div>
      </div>
    </Modal>
  );
};

export default ModalViewFacture;
